/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TournamentBracketSettingsInput
 */
export interface TournamentBracketSettingsInput {
    /**
     * 
     * @type {string}
     * @memberof TournamentBracketSettingsInput
     */
    seeding?: TournamentBracketSettingsInputSeedingEnum;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentBracketSettingsInput
     */
    thirdPlaceMatch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentBracketSettingsInput
     */
    grandFinalAdvantage?: boolean;
}


/**
 * @export
 */
export const TournamentBracketSettingsInputSeedingEnum = {
    random: 'random',
    ranked: 'ranked',
    manual: 'manual'
} as const;
export type TournamentBracketSettingsInputSeedingEnum = typeof TournamentBracketSettingsInputSeedingEnum[keyof typeof TournamentBracketSettingsInputSeedingEnum];


/**
 * Check if a given object implements the TournamentBracketSettingsInput interface.
 */
export function instanceOfTournamentBracketSettingsInput(value: object): value is TournamentBracketSettingsInput {
    return true;
}

export function TournamentBracketSettingsInputFromJSON(json: any): TournamentBracketSettingsInput {
    return TournamentBracketSettingsInputFromJSONTyped(json, false);
}

export function TournamentBracketSettingsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentBracketSettingsInput {
    if (json == null) {
        return json;
    }
    return {
        
        'seeding': json['seeding'] == null ? undefined : json['seeding'],
        'thirdPlaceMatch': json['thirdPlaceMatch'] == null ? undefined : json['thirdPlaceMatch'],
        'grandFinalAdvantage': json['grandFinalAdvantage'] == null ? undefined : json['grandFinalAdvantage'],
    };
}

export function TournamentBracketSettingsInputToJSON(json: any): TournamentBracketSettingsInput {
    return TournamentBracketSettingsInputToJSONTyped(json, false);
}

export function TournamentBracketSettingsInputToJSONTyped(value?: TournamentBracketSettingsInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'seeding': value['seeding'],
        'thirdPlaceMatch': value['thirdPlaceMatch'],
        'grandFinalAdvantage': value['grandFinalAdvantage'],
    };
}

